import { useLocation, useHistory } from 'react-router-dom';

export const usePaymentIdSync = () => {
  const location = useLocation();
  const history = useHistory();

  const getPaymentId = () => {
    const searchParams = new URLSearchParams(location.search);
    const paymentId = searchParams.get('paymentId');
    if (!paymentId) return undefined;
    return paymentId;
  };

  const setPaymentId = (id) => {
    const searchParams = new URLSearchParams(location.search);

    if (id) {
      searchParams.set('paymentId', id);
    } else {
      searchParams.delete('paymentId');
    }

    history.replace({
      pathname: location.pathname,
      search: searchParams.toString(),
    });
  };

  return {
    paymentId: getPaymentId(),
    setPaymentId,
  };
};
